import React, { FC } from 'react';
import cn from 'classnames';
import { Button, ButtonSizes, ButtonThemes } from '../../Button';
import { Icon } from '../../Icon';
import { ISwiperCarouselArrowsProps } from '../SwiperCarousel';
require("./SwiperCarouselArrows.css");
var styles = {
  "Root": "SwiperCarouselArrows-module-Root_2B6",
  "RootPrev": "SwiperCarouselArrows-module-RootPrev_2J4",
  "RootNext": "SwiperCarouselArrows-module-RootNext_31Z"
};
const SwiperCarouselArrows = ({
  prevEl,
  nextEl
}) => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    id: prevEl,
    className: cn(styles.Root, styles.RootPrev),
    size: ButtonSizes.s,
    theme: ButtonThemes.neutral,
    "aria-label": "\u041F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0438\u0439 \u0441\u043B\u0430\u0439\u0434"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "chevronBack"
  })), /*#__PURE__*/React.createElement(Button, {
    id: nextEl,
    className: cn(styles.Root, styles.RootNext),
    size: ButtonSizes.s,
    theme: ButtonThemes.neutral,
    "aria-label": "\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 \u0441\u043B\u0430\u0439\u0434"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "chevronRight"
  })));
};
export default SwiperCarouselArrows;